<script setup lang="ts">

import { ref } from "vue";
import { useResizeObserver } from "@vueuse/core";

import type { IBezierCurveOptions } from "./Types/IBezierCurveOptions";
import { BezierCurve } from "./Types/BezierCurve";

const model = defineModel<number[]>( { required: true } );
const sparkline = ref<BezierCurve>();

const element = ref();
const dimensions = ref( { width: 0, height: 0 } );
const padding = 4;

useResizeObserver( element, ( entries ) =>
{

    if( model.value.length < 1 ) return;
    
    const entry = entries[ 0 ]
    dimensions.value = entry.contentRect

    const options: IBezierCurveOptions = {
        maxPoints: 10,
        height: dimensions.value.height,
        width: dimensions.value.width,
        padding: padding
    }

    sparkline.value = new BezierCurve( model.value, options );

} );

</script>

<template>
    <div ref="element" 
         class="w-full h-full">
        <svg v-if="sparkline != null"
            :width="dimensions.width" 
            :height="dimensions.height"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:svgjs="http://svgjs.dev"
            transform="translate(0,0)" 
            style="background: transparent;">

            <g zIndex="0">
                <defs>
                    <linearGradient id="gradient" x1="0" y1="1" x2="1" y2="1">
                        <stop stop-color="#a425e0" offset="0"></stop>
                        <stop stop-color="#1f66d9" offset="1"></stop>
                    </linearGradient>
                </defs>
                <path :d="sparkline.svgPath"
                    fill="none" 
                    fill-opacity="1" 
                    stroke="url(#gradient)" 
                    stroke-opacity="1" 
                    stroke-linecap="round" 
                    stroke-width="5" 
                    stroke-dasharray="0" 
                    index="0" 
                    fill-rule="evenodd">
                </path>
            </g>
        </svg>
    </div>

</template>